import GetRequest from "../utilities/api/get-request";
import PostRequest from "../utilities/api/post-request";

class Site {
  /*
    |--------------------------------------------------------------------------
    | Get site details
    |--------------------------------------------------------------------------
    |
    */

  static async details() {
    const path = "/api/sites";

    return await GetRequest(path);
  }

  /*
    |--------------------------------------------------------------------------
    | Set faire access token
    |--------------------------------------------------------------------------
    |
    */
  static async setFaireAccessToken(data = {}) {
    const path = "/api/sites/set-faire-access-token";

    return await PostRequest(path, data);
  }

  /*
    |--------------------------------------------------------------------------
    | Get Faire Store Details
    |--------------------------------------------------------------------------
    |
    */

  static async faireStoreDetails() {
    const path = "/api/faire/details";

    return await GetRequest(path);
  }

  /*
    |--------------------------------------------------------------------------
    | Disconnect Faire account
    |--------------------------------------------------------------------------
    |
    */

  static async disconnectFaireAccount() {
    const path = "/api/sites/disconnect-faire";

    return await PostRequest(path);
  }

  static async replaceFaireAccessToken(data = {}) {
    const path = "/api/sites/replace-faire-access-token";

    return await PostRequest(path, data);
  }
}

export default Site;
